import { type FC } from "react";

export const Close: FC = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.5 12.5L12.5 37.5"
      stroke="#35424A"
      strokeWidth="2.11806"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 12.5L37.5 37.5"
      stroke="#35424A"
      strokeWidth="2.11806"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
